import { useDispatch, useSelector } from 'react-redux';
import { useCollaboration } from '../../../entities/collaboration';

import { pagesModel } from '../../../features/pages';
import { templatesModel } from '../../../features/templates';

import { TemplateExtended } from '@distribute/shared/api-types/templates';
import { Loader } from '../../../shared/ui';
import { NewEditor } from './NewEditor';
import { redirectActions } from '../../../entities/history';
import { logger } from '../../../shared/lib';
import { snackbarModel } from '../../../features/snackbar';
import { createNotification } from '../../../features/snackbar';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type Props = {
  isTemplateMode: boolean;
};

// Temporary solution for loading correct tabs for both cases.

export const NewEditorStrictTabs: React.FC<Props> = ({ isTemplateMode }) => {
  const dispatch = useDispatch();
  const { search } = useLocation();

  const { tabs: collaborativeTabs } = useCollaboration();

  const currentPageContentId = useSelector(
    pagesModel.selectors.selectCurrentContentId
  ) as number;

  const currentTemplate = useSelector(
    templatesModel.selectors.selectCurrentTemplate
  ) as TemplateExtended;

  const currentTemplateContentId = useSelector(
    templatesModel.selectors.selectCurrentTemplateContentId
  ) as number;

  useEffect(() => {
    if (isTemplateMode) {
      // Handled in template saga
      return;
    }

    if (collaborativeTabs.length === 0) {
      logger.error('Collaborative tabs are empty');
      dispatch(
        snackbarModel.actions.addNotificationAction(
          createNotification(
            'error',
            'Encountered an error while loading the page'
          )
        )
      );
      dispatch(redirectActions.toWorkspace());
      return;
    }

    const tabId = new URLSearchParams(search).get('tab');
    const tab =
      collaborativeTabs.find((tab) => tab.id === Number(tabId)) ??
      collaborativeTabs[0];

    if (tab) {
      dispatch(pagesModel.actions.setCurrentContentId(tab.id));
    }
    // Run only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isPageTabsReady = currentPageContentId && collaborativeTabs.length > 0;
  const isTemplateTabsReady =
    currentTemplateContentId &&
    currentTemplate.content?.contentItems.length > 0;

  if (!isPageTabsReady && !isTemplateMode) {
    return <Loader />;
  }

  if (!isTemplateTabsReady && isTemplateMode) {
    return <Loader />;
  }

  return <NewEditor isTemplateMode={isTemplateMode} />;
};
